// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .image-input-field {
  position: relative;
  width: 100%;
  height: 100%;
  margin-right: 20px;
}
:host .image-input-field.profile-photo {
  width: 110px;
}
:host .image-input-field.cover-photo {
  width: 580px;
}
@media screen and (max-width: 550px) {
  :host .image-input-field {
    width: 100%;
  }
}
:host .image-input-field .text-info-cont {
  width: 100%;
  height: 100%;
}
:host .image-input-field .change-btn {
  background: #bdc3c7;
  color: white;
  border: none;
  height: 38px;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border-radius: 3px;
  margin-top: 20px;
  cursor: pointer;
}
:host .image-input-field label {
  margin-bottom: 5px;
  font-family: Source Sans Pro;
  font-size: 11px;
  font-weight: 600;
  line-height: 16.5px;
  letter-spacing: 0.04em;
  text-align: left;
}
:host .image-input-field i.bi.bi-info-circle-fill {
  color: #cfcfcf;
  scale: 0.8;
}
:host .image-input-field i.bi.bi-info-circle-fill::before {
  scale: 0.9;
}
:host .image-input-field .image-preview-cont {
  width: 100%;
  height: auto;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
}
:host .image-input-field .image-preview-cont.video-preview {
  height: 100%;
  background: black;
}
:host .image-input-field .image-preview-cont:hover .crop-icon,
:host .image-input-field .image-preview-cont:hover .delete-icon,
:host .image-input-field .image-preview-cont:hover .upload-icon {
  display: inline-block !important;
}
:host .image-input-field .image-preview-cont .icons-cont {
  position: absolute;
  top: 10px;
  right: 11px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
:host .image-input-field .image-preview-cont .image-input-preview {
  width: inherit;
  height: inherit;
}
:host .image-input-field .image-preview-cont .image-preview {
  width: 300px;
  height: 300px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}
:host .image-input-field .image-preview-cont .crop-icon,
:host .image-input-field .image-preview-cont .delete-icon,
:host .image-input-field .image-preview-cont .upload-icon {
  display: none;
  transition: 0.3s;
}
:host .image-input-field .input-overlay {
  position: absolute;
  top: 0;
  left: 0;
  border: 1px solid #c8c5ca;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  font-style: italic;
  background-color: #fafafa;
  border-radius: 10px;
  text-align: center;
  font-size: 14px;
  padding: 10px 10px 0;
}
:host .image-input-field .input-overlay.error {
  outline: 2px solid #e10808 !important;
}
:host .image-input-field .input-overlay.error .error-msg {
  display: block;
}
:host .image-input-field .input-overlay .error-msg {
  display: none;
  position: absolute;
  bottom: -22px;
  font-size: 12px;
  color: #e10808;
  width: 100%;
  text-align: left;
  font-style: normal;
  font-weight: 600;
}
:host .image-input-field .input-overlay .input-desc {
  height: 100%;
  color: #aeaeae;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  padding-bottom: 40px;
}
:host .image-input-field .image-input-preview {
  width: inherit;
  height: inherit;
  border: 1px solid #c8c5ca;
  border-radius: 10px;
}
:host .image-input-field .image-preview {
  width: 300px;
  height: 300px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}
:host .image-input-field input[type=file] {
  position: relative;
  height: 100%;
  width: 100%;
  opacity: 0 !important;
}
:host .image-input-field input[type=file]:hover {
  cursor: pointer;
}
@media screen and (max-width: 550px) {
  :host .image-input-field input[type=file] {
    width: 125px;
    height: 125px;
  }
}
:host .image-input-field .upload-icon {
  width: 26px;
  height: 26px;
  display: block;
  background-image: url('data:image/svg+xml, <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="26" height="26" rx="6" fill="%23C8C5CA"/><g clip-path="url(%23clip0_1028_102106)"><path d="M7.66602 16.3333V17.6666C7.66602 18.0202 7.80649 18.3593 8.05654 18.6094C8.30659 18.8594 8.64573 18.9999 8.99935 18.9999H16.9993C17.353 18.9999 17.6921 18.8594 17.9422 18.6094C18.1922 18.3593 18.3327 18.0202 18.3327 17.6666V16.3333" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.66602 11.0001L12.9993 7.66675L16.3327 11.0001" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 7.66675V15.6667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1028_102106"><rect width="16" height="16" fill="white" transform="translate(5 5)"/></clipPath></defs></svg>');
}
:host .image-input-field .upload-icon:hover {
  background-image: url('data:image/svg+xml, <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="26" height="26" rx="6" fill="%23C8C5CA"/><g clip-path="url(%23clip0_1028_102106)"><path d="M7.66602 16.3333V17.6666C7.66602 18.0202 7.80649 18.3593 8.05654 18.6094C8.30659 18.8594 8.64573 18.9999 8.99935 18.9999H16.9993C17.353 18.9999 17.6921 18.8594 17.9422 18.6094C18.1922 18.3593 18.3327 18.0202 18.3327 17.6666V16.3333" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.66602 11.0001L12.9993 7.66675L16.3327 11.0001" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 7.66675V15.6667" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1028_102106"><rect width="16" height="16" fill="white" transform="translate(5 5)"/></clipPath></defs></svg>');
}
:host .image-input-field .delete-icon {
  color: #c8c5ca;
  width: 26px;
  height: 26px;
  display: block;
  background-image: url('data:image/svg+xml,<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="26" height="26" rx="6" fill="%23C8C5CA"/><path d="M19 7L7 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 7L19 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}
:host .image-input-field .delete-icon:hover {
  background-image: url('data:image/svg+xml,<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="26" height="26" rx="6" fill="%23C8C5CA"/><path d="M19 7L7 19" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 7L19 19" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}
:host .image-input-field .crop-icon {
  width: 26px;
  height: 26px;
  display: block;
  background-image: url('data:image/svg+xml,<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="26" height="26" rx="6" fill="%23C8C5CA"/><path d="M9.5 6V16.6061C9.5 16.8874 9.60057 17.1571 9.77958 17.356C9.95859 17.5549 10.2014 17.6667 10.4545 17.6667H20" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 9.5H16.6061C16.8874 9.5 17.1571 9.60057 17.356 9.77958C17.5549 9.95859 17.6667 10.2014 17.6667 10.4545V20" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}
:host .image-input-field .crop-icon:hover {
  background-image: url('data:image/svg+xml,<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="26" height="26" rx="6" fill="%23C8C5CA"/><path d="M9.5 6V16.6061C9.5 16.8874 9.60057 17.1571 9.77958 17.356C9.95859 17.5549 10.2014 17.6667 10.4545 17.6667H20" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 9.5H16.6061C16.8874 9.5 17.1571 9.60057 17.356 9.77958C17.5549 9.95859 17.6667 10.2014 17.6667 10.4545V20" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}
:host .image-input-field .video-input-preview {
  width: 100%;
  height: 100%;
}
:host .hide {
  display: none !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
